import { Dispatch, AnyAction } from 'redux';
import { store } from '../../../../appStore';
import { IAppState, UITabView } from '../../../../models/reduxState';
import {
  currentUITabViewSelector,
  showModalitiesStickyFooterBRSSelector,
} from '../../../app/selectors/contactUsSelector';
import { FreelanceRequest } from '../../models/requestModels';
import {
  updateDraftRequest,
  updateIsEmailValid,
  updateIsPhoneNumberValid,
  updateBusinessImpactConfirmed,
  updateCustomerAvailabilityConfirmed,
  updateIsTitleValid,
  updateShowAgentModalitiesButton,
} from '../actions/modalitySectionActions';
import {
  updateDirtyRequest,
  updateIsEmailValidForEdit,
  updateIsPhoneNumberValidForEdit,
  updateBusinessImpactConfirmedForEdit,
  updateCustomerAvailabilityConfirmedForEdit,
} from '../actions/requestDetailsActions';

/**
 * depending on the current tab, we'll update draftRequest or dirtyRequest
 */
export const dispatchUpdateRequest = (request: FreelanceRequest) => {
  return async (dispatch: Dispatch<AnyAction>, _getState: () => IAppState) => {
    const state = store.getState();
    const currentUiTabView = currentUITabViewSelector(state);
    // we currently don't have request history or request edit for stickyFooter == false, so update draft request
    if (!showModalitiesStickyFooterBRSSelector(state)) {
      dispatch(updateDraftRequest(request));
    } else if (!!currentUiTabView) {
      switch (currentUiTabView) {
        case UITabView.requestCreation:
          dispatch(updateDraftRequest(request));
          break;
        case UITabView.requestDetails:
          dispatch(updateDirtyRequest(request));
          break;
        default:
          break;
      }
    }
  };
};

/**
 * depending on the current tab, update isPhoneNumberValid inside RequestDetailsReducer or ModalitySectionReducer
 */
export const dispatchUpdateIsPhoneNumberValid = (isPhoneNumberValid: boolean) => {
  return async (dispatch: Dispatch<AnyAction>, _getState: () => IAppState) => {
    const state = store.getState();
    const currentUiTabView = currentUITabViewSelector(state);
    // we currently don't have request history or request edit for stickyFooter == false, so update draft request
    if (!showModalitiesStickyFooterBRSSelector(state)) {
      dispatch(updateIsPhoneNumberValid(isPhoneNumberValid));
    } else if (!!currentUiTabView) {
      switch (currentUiTabView) {
        case UITabView.requestCreation:
          dispatch(updateIsPhoneNumberValid(isPhoneNumberValid));
          break;
        case UITabView.requestDetails:
          dispatch(updateIsPhoneNumberValidForEdit(isPhoneNumberValid));
          break;
        default:
          break;
      }
    }
  };
};

/**
 * depending on the current tab, update isEmailValid inside RequestDetailsReducer or ModalitySectionReducer
 */
export const dispatchUpdateIsEmailValid = (isEmailValid: boolean) => {
  return async (dispatch: Dispatch<AnyAction>, _getState: () => IAppState) => {
    const state = store.getState();
    const currentUiTabView = currentUITabViewSelector(state);
    // we currently don't have request history or request edit for stickyFooter == false, so update draft request
    if (!showModalitiesStickyFooterBRSSelector(state)) {
      dispatch(updateIsEmailValid(isEmailValid));
    } else if (!!currentUiTabView) {
      switch (currentUiTabView) {
        case UITabView.requestCreation:
          dispatch(updateIsEmailValid(isEmailValid));
          break;
        case UITabView.requestDetails:
          dispatch(updateIsEmailValidForEdit(isEmailValid));
          break;
        default:
          break;
      }
    }
  };
};

export const dispatchUpdateIsTitleValid = (isTitleValid: boolean) => {
  return async (dispatch: Dispatch<AnyAction>) => {
    dispatch(updateIsTitleValid(isTitleValid));
  };
};

export const dispatchUpdateShowAgentModalitiesButton = (showAgentModalitiesButtonClicked: boolean) => {
  return async (dispatch: Dispatch<AnyAction>) => {
    dispatch(updateShowAgentModalitiesButton(showAgentModalitiesButtonClicked));
  };
};

/**
 * depending on the current tab, update updateBusinessImpactConfirmed inside RequestDetailsReducer or ModalitySectionReducer
 */
export const dispatchUpdateBusinessImpactConfirmed = (businessImpactConfirmed: boolean) => {
  return async (dispatch: Dispatch<AnyAction>, _getState: () => IAppState) => {
    const state = store.getState();
    const currentUiTabView = currentUITabViewSelector(state);
    // we currently don't have request history or request edit for stickyFooter == false, so update draft request
    if (!showModalitiesStickyFooterBRSSelector(state)) {
      dispatch(updateBusinessImpactConfirmed(businessImpactConfirmed));
    } else if (!!currentUiTabView) {
      switch (currentUiTabView) {
        case UITabView.requestCreation:
          dispatch(updateBusinessImpactConfirmed(businessImpactConfirmed));
          break;
        case UITabView.requestDetails:
          dispatch(updateBusinessImpactConfirmedForEdit(businessImpactConfirmed));
          break;
        default:
          break;
      }
    }
  };
};

/**
 * depending on the current tab, update CustomerAvailabilityConfirmed inside RequestDetailsReducer or ModalitySectionReducer
 */
export const dispatchCustomerAvailabilityConfirmed = (customerAvailabilityConfirmed: boolean) => {
  return async (dispatch: Dispatch<AnyAction>, _getState: () => IAppState) => {
    const state = store.getState();
    const currentUiTabView = currentUITabViewSelector(state);
    // we currently don't have request history or request edit for stickyFooter == false, so update draft request
    if (!showModalitiesStickyFooterBRSSelector(state)) {
      dispatch(updateCustomerAvailabilityConfirmed(customerAvailabilityConfirmed));
    } else if (!!currentUiTabView) {
      switch (currentUiTabView) {
        case UITabView.requestCreation:
          dispatch(updateCustomerAvailabilityConfirmed(customerAvailabilityConfirmed));
          break;
        case UITabView.requestDetails:
          dispatch(updateCustomerAvailabilityConfirmedForEdit(customerAvailabilityConfirmed));
          break;
        default:
          break;
      }
    }
  };
};
